import {styled} from '../../utils';
import {Main} from '../Layout';

export default styled(Main)(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: theme.fontSize.base,
  padding: 25
}));



// WEBPACK FOOTER //
// ./src/components/Card/CardBody.tsx